/**
 * Sticky
 *
 * Adds a sticky CSS class to specified elements while scrolling
 *
 * element needs:
 * class="has-sticky" (selector)
 * data-offset="120" (offset for when class should be added)
 *
 * optional:
 * data-affected="body:is-scrolling,.something:col-12" (DOM element : css class - adds the class to the element, can be a comma separated list)
 */

(function Sticky() {
    const elements = $('.has-sticky');
    const classes = {
        sticky: 'is-sticky'
    };

    /**
     * Create
     */
    function create() {
        $.each(elements, function(index, element) {
            let sticky = $(element);

            listen(sticky);

            window.onscroll = function() {
                listen(sticky);
            };

            cleanup(sticky);
        });
    }

    /**
     * Listen for event(s)
     * @param element
     */
    function listen(element) {
        let offset = typeof element.data('offset') != 'undefined' ? element.data('offset') : element.position().top;
        let affected = typeof element.data('affected') != 'undefined' ? getAffectedElements(element.data('affected')) : null;

        if (window.pageYOffset > offset) {
            element.addClass(classes.sticky);
            addAffectedClasses(affected);
        }

        if (window.pageYOffset <= offset){
            element.removeClass(classes.sticky);
            removeAffectedClasses(affected);
        }
    }

    /**
     * Returns an array of element:cssClass set
     *
     * @param affectedData
     * @returns {{values: Array, valPol: Array, pointer: number, numberMode: number, theVal: string}|null|*|string[]}
     */
    function getAffectedElements(affectedData) {
        return affectedData.split(',');
    }

    /**
     * Adds the specified cssClass for each defined element
     *
     * @param items
     */
    function addAffectedClasses(items) {
        if (null !== items) {
            for (var i in items) {
                let data = items[i].split(':');
                let element = $(data[0]);

                if (!element.hasClass(data[1])) {
                    element.addClass(data[1]);
                }
            }
        }
    }

    /**
     * Removes the specified cssClass for each defined element
     *
     * @param items
     */
    function removeAffectedClasses(items) {
        if (null !== items) {
            for (var i in items) {
                let data = items[i].split(':');
                let element = $(data[0]);

                if (element.hasClass(data[1])) {
                    element.removeClass(data[1]);
                }
            }
        }
    }

    /**
     * Cleanup DOM
     * @param element
     */
    function cleanup(element) {
        if (typeof element == 'undefined') {
            element = $(classes.sticky);
        }

        element
            .removeClass(classes.sticky)
            .removeAttr('data-offset')
            .removeAttr('data-affected');
    }

    if (elements.length > 0) {
        create();
    }

})();